import React from "react";
import { Divider } from "@lightspeed/flame/Divider";

const SideListItem = ({ item, setDashMain, current, onClick }) => {
  const { company_id, company_name, url_link } = item;
  const isAddNewLocation = String(company_name || "")
    .toLowerCase()
    .includes("add new location");

  const dynamicClass = String(company_id) === String(current) ? "side-list-active" : "";

  function handleLinkClick(event) {
    if (!url_link) {
      event.preventDefault();
    }
  }

  return (
    <div
      onClick={() => {
        if (setDashMain) setDashMain(false);
        if (onClick && !isAddNewLocation) onClick(String(company_id));
      }}
      className={`side-list ${dynamicClass} ${
        isAddNewLocation ? "side-list-add-location" : ""
      }`}
    >
      <p>
        <a
          href={url_link}
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleLinkClick}
        >
          {company_name}
        </a>
      </p>

      <Divider />
    </div>
  );
};

export default SideListItem;
